import React from 'react';
import { Box, SimpleGrid } from '@chakra-ui/core';

import ModalFormule from './ModalFormule';

export default function PlateModal({
  formuleState,

  selected,
  post,
}) {
  const [reload, setReload] = React.useState(selected);
  React.useEffect(() => {
    // ('reloadeddddddd');
  }, [reload]);
  return (
    <Box p="30px">
      <SimpleGrid mt="6" mb="50px" columns={[1, 1, 2, 3]} spacing={12}>
        {post.formules.map(formule => (
          <ModalFormule
            key={formule.id}
            setReload={setReload}
            selected={selected}
            formuleState={formuleState}
            post={post}
            formule={formule}
          ></ModalFormule>
        ))}
      </SimpleGrid>
    </Box>
  );
}
